const columns = [
    {
        title: 'Ticket No.',
        dataIndex: 'ticketNo',
        // sorter: true,
    },
    {
        title: 'Query Type',
        dataIndex: 'queryType',
        // sorter: true,
    },
    {
        title: 'Title',
        dataIndex: 'title',
        // sorter: true,
    },
    {
        title: 'Name',
        dataIndex: 'name',
        // sorter: true,
    },
    {
        title: 'Create At',
        dataIndex: 'createdAt',
        // sorter: true,
    },
    {
        title: 'Priority',
        dataIndex: 'priority',
        // sorter: true,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        // sorter: true,
    },
    {
        title: 'Details',
        dataIndex: 'details',
    },
];

export default columns;